var _ellipse, _ellipse2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 13.3333,
    cy: 22.6666,
    rx: 9.33333,
    ry: 5.33333,
    fill: "#9FA6AB"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.3333,
    cy: 9.33333,
    rx: 5.33333,
    ry: 5.33333,
    fill: "#9FA6AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0997 11.4329C22.474 11.0586 23.0809 11.0586 23.4552 11.4329L25.3334 13.3111L27.2116 11.4329C27.5859 11.0586 28.1928 11.0586 28.5671 11.4329C28.9414 11.8072 28.9414 12.4141 28.5671 12.7884L26.6889 14.6666L28.5671 16.5448C28.9414 16.9191 28.9414 17.5259 28.5671 17.9002C28.1928 18.2746 27.5859 18.2746 27.2116 17.9002L25.3334 16.0221L23.4552 17.9002C23.0809 18.2746 22.474 18.2746 22.0997 17.9002C21.7254 17.5259 21.7254 16.9191 22.0997 16.5448L23.9779 14.6666L22.0997 12.7884C21.7254 12.4141 21.7254 11.8072 22.0997 11.4329Z",
    fill: "#9FA6AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserRemove);
export default __webpack_public_path__ + "static/media/user-remove.3b5cc571ca230c3e418213c328a35fc5.svg";
export { ForwardRef as ReactComponent };